/**
 * Window event asking the header to open its mini-cart (CPS-7695), so a page
 * such as the PDP's View in cart CTA can open it without sharing state with
 * the header, which owns the drawer.
 */
export const OPEN_MINI_CART_EVENT = 'compass:open-mini-cart';

/**
 * Where focus goes when the drawer closes: back to the page control that had
 * it when the drawer was asked for, or to the header cart button.
 */
export type MiniCartReturnFocus = 'requester' | 'cart-button';

type MiniCartOpenRequest = { returnFocus: MiniCartReturnFocus };

/** The single call site pages use to open the header mini-cart. */
export const requestMiniCartOpen = ({
  returnFocus = 'requester',
}: Partial<MiniCartOpenRequest> = {}): void => {
  window.dispatchEvent(
    new CustomEvent<MiniCartOpenRequest>(OPEN_MINI_CART_EVENT, {
      detail: { returnFocus },
    })
  );
};

/** The header subscribes here; returns the unsubscribe for an effect cleanup. */
export const subscribeToMiniCartOpenRequest = (
  listener: (request: MiniCartOpenRequest) => void
): (() => void) => {
  const onRequest = (event: Event) =>
    listener((event as CustomEvent<MiniCartOpenRequest>).detail);
  window.addEventListener(OPEN_MINI_CART_EVENT, onRequest);
  return () => window.removeEventListener(OPEN_MINI_CART_EVENT, onRequest);
};
